export const USER_ROLE = {
  ADMINISTRATOR: 'administrator',
  SELLER: 'seller',
  SALES_MANAGER: 'sales-manager',
  RECEPCIONIST: 'recepcionist',
  SCANNER: 'scanner',
  MOBILE_APP_ADMIN: 'mobile_app_admin',
  /** Solo dentro de un evento con `report_global`: ve todo lo vendido en ese evento. */
  GLOBAL_REPORT: 'global-report',
  UNKNOWN: 'unknown',
} as const;

export type UserRoleType = typeof USER_ROLE[keyof typeof USER_ROLE];

/** Roles con los que se ve el reporte del evento (`/sales-manager-home/:eventId`). */
export const REPORT_ROLES: ReadonlySet<UserRoleType> = new Set<UserRoleType>([
  USER_ROLE.ADMINISTRATOR,
  USER_ROLE.SALES_MANAGER,
  USER_ROLE.GLOBAL_REPORT,
]);

export function isReportRole(role: UserRoleType): boolean {
  return REPORT_ROLES.has(role);
}
